import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ConfirmationState {
  isOpen: boolean;
  title: string;
  subtitle?: string;
  confirmButton: {
    text: string;
    variant?: 'primary' | 'danger' | 'warning' | 'success';
  };
  cancelButton: {
    text: string;
    variant?: 'secondary' | 'outline-secondary';
  };
  originalAction?: any;
  actionType?: string;
  actionPayload?: any;
}

const initialState: ConfirmationState = {
  isOpen: false,
  title: '',
  subtitle: undefined,
  confirmButton: {
    text: 'Confirm',
    variant: 'primary',
  },
  cancelButton: {
    text: 'Cancel',
    variant: 'secondary',
  },
};

const confirmationSlice = createSlice({
  name: 'confirmation',
  initialState,
  reducers: {
    showConfirmation: (state, action: PayloadAction<Omit<ConfirmationState, 'isOpen'>>) => {
      return {
        ...state,
        ...action.payload,
        isOpen: true,
      };
    },
    hideConfirmation: () => {
      return {
        ...initialState,
        isOpen: false,
      };
    },
    updateConfirmation: (state, action: PayloadAction<Partial<ConfirmationState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    cancelAction: () => {
      return {
        ...initialState,
        isOpen: false,
      };
    },
  },
});

export const confirmAction = createAction('confirmation/confirmAction');

export const { showConfirmation, hideConfirmation, updateConfirmation, cancelAction } = confirmationSlice.actions;

export const confirmationReducer = confirmationSlice.reducer;
